
export type AuthProvider = string;

export enum AuthProviders {
    facebook = 'facebook.com',
    google = 'google.com',
    password = 'password',
    phone = 'phone',
}
